// @flow
import React, { useCallback } from 'react';
import { withApollo } from 'react-apollo';
import CustomAsyncSelect, { CustomAsyncSelectProps } from './CustomAsyncSelect';
import { ALL_PROJECTS_OPTION } from '../../utils/consts';
import { getJiraProjects } from '../../services/jira-services';

export const parseProjectsToOptions = (projects) => {
    return (projects || [])
        .map((p) => ({
            value: p.jiraProjectId ?? p.id,
            label: p.jiraProjectName ?? p.name,
            avatar: p.avatarUrls?.['48x48'] ?? p.avatarUrls?.large,
            obj: p,
        }))
        .sort((a, b) => {
            return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
        });
};

export const parseProjectsToOptionsGroups = (projects) => {
    return [
        {
            label: 'QUICK ACTION',
            options: [
                {
                    label: 'Add all projects',
                    value: ALL_PROJECTS_OPTION,
                },
            ],
        },
        {
            label: 'PROJECTS',
            options: parseProjectsToOptions(projects),
        },
    ];
};

const loadProjectsAndParseToOptions = async (searchText: string, projectsToOptionsParser: (projects: any) => any) => {
    const resultBody = await getJiraProjects({
        searchText,
        maxResultsPerPage: !searchText ? 10 : undefined,
        maxPages: 1,
    });
    return projectsToOptionsParser(resultBody);
};

export const loadProjectsOptions = (searchText: string) => {
    return loadProjectsAndParseToOptions(searchText, parseProjectsToOptions);
};

export const loadProjectsOptionsWithAddAll = (searchText: string) => {
    return loadProjectsAndParseToOptions(searchText, parseProjectsToOptionsGroups);
};

export interface ProjectSelectProps extends CustomAsyncSelectProps {
    includeAddAll?: boolean;
    projectKey?: string;
}

const ProjectSelect = ({ includeAddAll = false, ...props }: ProjectSelectProps) => {
    const loadOptions = useCallback(
        async (searchText: string) => {
            if (includeAddAll) {
                return loadProjectsOptionsWithAddAll(searchText);
            }
            return loadProjectsOptions(searchText);
        },
        [includeAddAll],
    );

    return <CustomAsyncSelect loadOptions={loadOptions} cacheOptions {...props} />;
};

export default withApollo(ProjectSelect);
